import { useState, useEffect } from 'react';

/**
 * Which theme is on the document right now, kept current by watching the class lib/theme.js
 * writes to <html>. For colours that cannot be CSS classes: chart ramps (AdminAnalyticsPage) and
 * the gem-bag tier colours, which arrive as data.
 *
 * Each caller watches for itself while mounted. lib/theme.js deliberately has no subscriber of
 * its own, so using this reaches no other page.
 */
export function useIsLight() {
  const read = () => typeof document !== 'undefined' && document.documentElement.classList.contains('light');
  const [light, setLight] = useState(read);
  useEffect(() => {
    const el = document.documentElement;
    const ob = new MutationObserver(() => setLight(el.classList.contains('light')));
    ob.observe(el, { attributes: true, attributeFilter: ['class'] });
    setLight(el.classList.contains('light'));
    return () => ob.disconnect();
  }, []);
  return light;
}
